import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import { createCustomer, getCustomerDetail } from "../../slices/customers";
import { convertErrorsFromServer } from "../../utils";

const CustomerCreate = ({onSuccess}) => {

    const dispatch = useDispatch()

    const {
        register,
        handleSubmit,
        reset,
        watch,
        setValue,
        setError,
        formState: { errors }
    } = useForm({
        defaultValues: {
            name: "",
            customer_reference: "",
            email: "",
            phone: "",
            address: {
                address_1: "",
                address_2: "",
                address_3: "",
                city: "",
                zip_code: "",
            }
        }
    });

    const onSubmit = (data) => {
        Promise.resolve(dispatch(createCustomer({ args: data })))
        .then(data => {
            if (data.meta.requestStatus === "rejected") {
                convertErrorsFromServer(data.payload).forEach(({name, type, message}) => {
                    setError(name, { type, message })
                })
            } else {
                onSuccess(data.payload.id)
            }
        })
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
                <h2>{gettext('Customer')}</h2>
                <div className="col-md-8 col-12 mb-4">
                    <label>{gettext('Name')}</label>
                    <input type="text" {...register("name", { required: gettext('Field cannot be blank')})} className={`form-control ${errors.name && "is-invalid"}`} />
                    {errors.name && <div className="invalid-feedback">{errors.name.message}</div>}
                </div>
                <div className="col-md-4 col-12 mb-4">
                    <label>{gettext('Customer reference')}</label>
                    <input type="text" {...register("customer_reference", { required: gettext('Field cannot be blank')})} className={`form-control ${errors.customer_reference && "is-invalid"}`} />
                    {errors.customer_reference && <div className="invalid-feedback">{errors.customer_reference.message}</div>}
                </div>
            </div>
            <div className="row">
                <div className="col-md-8 col-12 mb-4">
                    <label>{gettext('Email')}</label>
                    <input type="text" {...register("email")} className={`form-control ${errors.email && "is-invalid"}`} />
                    {errors.email && <div className="invalid-feedback">{errors.email.message}</div>}
                </div>
                <div className="col-md-4 col-12 mb-4">
                    <label>{gettext('Phone number')}</label>
                    <input type="text" {...register("phone")} className={`form-control ${errors.phone && "is-invalid"}`} />
                    {errors.phone && <div className="invalid-feedback">{errors.phone.message}</div>}
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-12 mb-4">
                    <label>{gettext('Address')}</label>
                    <input type="text" {...register("address.address_1")} className={`form-control ${errors.addressaddress_1 && "is-invalid"}`} />
                    {errors.addressaddress_1 && <div className="invalid-feedback">{errors.addressaddress_1.message}</div>}
                </div>
                <div className="col-md-2 col-4 mb-4">
                    <label>{gettext('Zip code')}</label>
                    <input type="text" {...register("address.zip_code")} className={`form-control ${errors.addresszip_code && "is-invalid"}`} />
                    {errors.addresszip_code && <div className="invalid-feedback">{errors.addresszip_code.message}</div>}
                </div>
                <div className="col-md-4 col-8 mb-4">
                    <label>{gettext('City')}</label>
                    <input type="text" {...register("address.city")} className={`form-control ${errors.addresscity && "is-invalid"}`} />
                    {errors.addresscity && <div className="invalid-feedback">{errors.addresscity.message}</div>}
                </div>
                <div className="col-md-6 col-12 mb-4">
                    <label>{gettext('Address 2')}</label>
                    <input type="text" {...register("address.address_2")} className={`form-control ${errors.addressaddress_2 && "is-invalid"}`} />
                    {errors.addressaddress_2 && <div className="invalid-feedback">{errors.addressaddress_2.message}</div>}
                </div>
                <div className="col-md-6 col-12 mb-4">
                    <label>{gettext('Address 3')}</label>
                    <input type="text" {...register("address.address_3")} className={`form-control ${errors.addressaddress_3 && "is-invalid"}`} />
                    {errors.addressaddress_3 && <div className="invalid-feedback">{errors.addressaddress_3.message}</div>}
                </div>
            </div>
            <div className="row d-block">
                <div className="col position-relative p-0 text-end">
                <button type="submit" className="btn btn-primary">{gettext('Save')}</button>
                </div>
            </div>
        </form>
    )
}

export default CustomerCreate